import React, {useState,useEffect} from 'react';
import {Container,Row,Table,Col,Form,Button} from 'react-bootstrap';
import { number_format } from '../../utils/utils';
import MenuTop from '../MenuTop/MenuTop';
import './Cobranza.css';

const Cobranza = ({socket}) => {

  const [cobranza,setCobranza] = useState([]);
  const [isLoading,setIsLoading] = useState(false);
  const [dateEnd,setDateEnd] = useState('2023-01-25')
  const [dateStart,setDateStart] = useState('2023-01-25')
 useEffect(() => {
    setIsLoading(true);
    getCobranza();
  },[])

  const getCobranza = () =>{
    const data = {
      date_start: dateStart.replace("/","-"),
      date_end: dateEnd.replace("/","-" ) 
    };

   fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getCobranzaByDate',{
      method: 'POST',
      model: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json())
    .then( res => {
      setCobranza(res.documents)
      setIsLoading(false);
    } )
  }

  


  const searcCobranzaByDate = (e) => {
    e.preventDefault();
    setIsLoading(true);
    getCobranza();
  }
  
  return(
    <Container fluid>
      <div className="ws-main-container">
        <MenuTop />
        <hr />
        <h5 style={{color:'#606060'}}>Cobranza</h5>
        <div className="ws-tab-container pb-3">
          <Row>
            <Col xs={12} md={3}>
              <Form onSubmit={(e)=>searcCobranzaByDate(e)}>
                <Row>
                  <Col>
                    <Form.Group className="d-flex flex-row">
                      <Form.Control type="date" value={dateStart} onChange={ (e) => setDateStart(e.target.value) } />
                      <Form.Control type="date" value={dateEnd} onChange={ (e) => setDateEnd(e.target.value) } />
                    </Form.Group>
                  </Col>
                  <Col className="d-flex align-items-end">
                    <Form.Group>
                      <Button type="submit" className="ws-btn-blue-2">Buscar</Button>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
        <Row>
          <Col xs={12}>
            <div className="ws-box-container">
             { (isLoading) && (<div className="ws-loader-container"><div className="spinner"></div></div>) }
              <Table responsive hover>
                <thead>
                  <tr>
                    <th width="20%">Id</th>
                    <th width="40%">Cantidad Recibida</th>
                    <th width="40%">Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    (cobranza.length>0) ? 
                      cobranza.map((t,e) => (
                        <tr>
                          <td style={{ padding: '15px 0', }}>{t.id_cotizacion}</td>
                          <td style={{ padding: '15px 0', }}>{(t.cantidadRecibida!=='') ? `$${number_format(t.cantidadRecibida)}` : t.cantidadRecibida}</td>
                          <td style={{ padding: '15px 0', }}>{t.created_at}</td>
                        </tr>
                      ))
                    : 
                    <tr>
                      <td colSpan={3} className="text-center">No hay resultados</td>
                    </tr>
                  }
                </tbody>
              </Table> 
            </div>
          </Col>
        </Row>
      </div>
      
    </Container>
  )
}

export default Cobranza;
